import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

$(function() {
    if ($('.wheel__bsmart').length) {
        const isDesktop = window.innerWidth > 1100;

        if (isDesktop) {
            gsap.registerPlugin(ScrollTrigger);

            ScrollTrigger.create({
                trigger: '.wheel__container--pinned',
                start: '0px top',
                end: '+=900',
                markers: false,
                scrub: true,
                pin: '.wheel__container--pinned',
                onUpdate: self => {
                    const scrollHeight = self.end - self.start;
                    const segmentHeight = scrollHeight / 5.5;
                    const scrollTop = self.scroll() - self.start;
                    const offset = 10;
                    let segment = Math.floor(scrollTop / segmentHeight) + 1;
                    segment = Math.min(Math.max(segment, 1), 5);
                    const classesToToggle = ['pie-item', 'wheel__contentText', 'arrow-wheel'];
                    classesToToggle.forEach(className => {
                        var elements = document.querySelectorAll('.' + className);
                        elements.forEach((element, index) => {
                            if (index + 1 === segment) {
                                element.classList.add('active');
                            } else {
                                element.classList.remove('active');
                            }

                            if (segment === elements.length) {
                                elements[elements.length - 1].classList.add('active');
                            }
                        });
                    });
                },
            });

            $('body').on('click', '.pie-item', function() {
                let scrollPosition = window.scrollY;
                ScrollTrigger.disable();
                window.scrollTo(0, scrollPosition);

                $('.pie-item.active, .wheel__contentText.active, .arrow-wheel.active').removeClass('active');
                $(this).addClass('active');

                $('.wheel__contentText')
                    .eq($(this).index())
                    .addClass('active');

                $('.arrow-wheel')
                    .eq($(this).index())
                    .addClass('active');
            });
        }
    }
});
